export interface CatalogGrade {
  GradeId: number | null;
  GradeName: string;
  Comments: string | null;
  Author: string;
  DateTimeModified: Date;
  Enabled: boolean;
  IsActive: boolean;
  IsDuplicate: boolean;
}

export const CATALOG_GRADE_INITIAL_VALUES: CatalogGrade = {
  GradeId: null,
  GradeName: "",
  Comments: null,
  Author: "",
  DateTimeModified: new Date(),
  Enabled: true,
  IsActive: true,
  IsDuplicate: false,
};

export interface GradeChemistryLimit {
  GradeId: number;
  ElementId: number | null;
  ElementName: string;
  MinValue: number;
  MaxValue: number;
  AimValue: number | null;
  Enabled: boolean | null;
}
